class AppController {
    constructor($translate, languageService, cacheService, CONFIG, $window, sharedService) {
        'ngInject';
        this.name = 'home';
        this.$translate = $translate;
        this.CONFIG = CONFIG;
        this.cacheService = cacheService;
        this.languageService = languageService;
        this.setLanguage();

        //TODO: move to file service
        let isMobile = {
            Android: function () {
                return $window.navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return $window.navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return $window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return $window.navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return $window.navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };
        sharedService.IS_MOBILE = isMobile.any();
    }

    //TODO: Move to service, using the same func on loginController
    setLanguage() {
        this.languageService.setLanguage(this.cacheService.get('customer').language || null);
    }

}

export default AppController;


// WEBPACK FOOTER //
// ./client/app/app.controller.js